import { Component, mergeProps } from 'solid-js';
import {
  ICON_CONTEXT_MENU_DEFAULTS,
  IconContextMenuSettings,
} from './IconContextMenu.types';
import { AnchoredContextMenu } from './AnchoredContextMenu';

export * from './IconContextMenu.types';

export const IconContextMenu: Component<Partial<IconContextMenuSettings>> = (
  props: Partial<IconContextMenuSettings>
) => {
  const activeProps = mergeProps(ICON_CONTEXT_MENU_DEFAULTS, props);

  return (
    <AnchoredContextMenu
      name={activeProps.name}
      menuItems={activeProps.menuItems}
      value={activeProps.value}
      menuPlacement={activeProps.menuPlacement}
      tabAligned={activeProps.tabAligned}
      onSelection={activeProps.onSelection}
    >
      <modus-wc-icon
        data-testid="icon"
        decorative
        name={activeProps.iconName}
        size={activeProps.iconSize}
      />
    </AnchoredContextMenu>
  );
};

export default IconContextMenu;
